import {
  DURUM_ETIKETI,
  ITIRAZ_DURUM_ETIKETI,
  type DonemDurumu,
  type ItirazDurumu,
} from '../api/donem';

/**
 * DÖNEM EKRANLARININ PAYLAŞILAN PARÇALARI.
 *
 * `Donem.tsx` · `DonemMutabakat.tsx` · `DonemItiraz.tsx` bunları paylaşıyor;
 * birinin içinde bırakılsaydı SÖZLEŞME §17'deki döngü dördüncü kez oluşurdu.
 */

const DURUM_BICIMI: Record<DonemDurumu, string> = {
  acik: 'bg-sky-50 text-sky-700 ring-sky-200',
  on_kapanis: 'bg-amber-50 text-amber-800 ring-amber-200',
  itiraz_penceresi: 'bg-orange-50 text-orange-800 ring-orange-200',
  kesin_kapanis: 'bg-violet-50 text-violet-700 ring-violet-200',
  kilitli: 'bg-slate-800 text-white ring-slate-800',
};

export function DonemDurumRozeti({ durum }: { durum: DonemDurumu }) {
  return (
    <span
      className={`whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${DURUM_BICIMI[durum]}`}
    >
      {DURUM_ETIKETI[durum]}
    </span>
  );
}

const ITIRAZ_BICIMI: Record<ItirazDurumu, string> = {
  acik: 'bg-amber-50 text-amber-800 ring-amber-200',
  inceleniyor: 'bg-sky-50 text-sky-700 ring-sky-200',
  kabul: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  red: 'bg-red-50 text-red-700 ring-red-200',
  iptal: 'bg-slate-50 text-slate-500 ring-slate-200',
};

export function ItirazDurumRozeti({ durum }: { durum: ItirazDurumu }) {
  return (
    <span
      className={`whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${ITIRAZ_BICIMI[durum]}`}
    >
      {ITIRAZ_DURUM_ETIKETI[durum]}
    </span>
  );
}

/**
 * PARASAL METİN GÖSTERİMİ.
 *
 * Değer METİN olarak gelir (`'842300.00'`) ve METİN olarak gösterilir; yalnız
 * binlik ayracı eklenir. `Number()`a çevrilip `toLocaleString` ile
 * biçimlenseydi aylık toplamda kuruş kaybı birikir ve mutabakat farkı yapay
 * olarak büyürdü.
 */
export function tutarMetni(deger: string | null): string {
  if (deger === null) return '—';

  const [tam, kesir] = deger.split('.');
  if (tam === undefined) return deger;

  // Binlik ayracı sağdan üçerli, METİN üzerinde.
  const ayrilmis = tam.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return kesir === undefined ? ayrilmis : `${ayrilmis},${kesir}`;
}
